(() => {
  const STORAGE_KEY = 'recently_viewed_products';
  const LIMIT = 12;

  const readHandles = () => {
    try {
      const value = JSON.parse(localStorage.getItem(STORAGE_KEY));
      return Array.isArray(value) ? value.filter((handle) => typeof handle === 'string') : [];
    } catch (error) {
      return [];
    }
  };

  const saveCurrentProduct = () => {
    const match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    if (!match) return;

    const handle = decodeURIComponent(match[1]);
    const handles = readHandles().filter((item) => item !== handle);

    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify([handle, ...handles].slice(0, LIMIT)));
    } catch (error) {
      // Browsing still works when storage is unavailable.
    }
  };

  const localizedProductUrl = (rootUrl, handle, extension = '') => {
    const root = rootUrl.endsWith('/') ? rootUrl : `${rootUrl}/`;
    return `${root}products/${encodeURIComponent(handle)}${extension}`;
  };

  const resizedImageUrl = (source) => {
    if (!source) return '';

    try {
      const url = new URL(source, window.location.origin);
      url.searchParams.set('width', '240');
      return url.toString();
    } catch (error) {
      return source;
    }
  };

  const createItem = (product, rootUrl) => {
    if (!product?.handle || !product?.featured_image) return null;

    const item = document.createElement('div');
    const link = document.createElement('a');
    const image = document.createElement('img');
    const title = document.createElement('span');

    item.className = 'rvp-item';
    item.dataset.labooProductHandle = product.handle;
    item.dataset.labooProductTitle = product.title || '';
    link.href = localizedProductUrl(rootUrl, product.handle);
    link.setAttribute('aria-label', product.title || 'View product');
    image.src = resizedImageUrl(product.featured_image);
    image.alt = product.title || '';
    image.width = 200;
    image.height = 250;
    image.loading = 'lazy';
    image.decoding = 'async';
    // 1 Nov 2026 (Tony): the name sits in its own row under the picture so the wishlist heart goes beside it, not on the image
    const row = document.createElement('div');
    row.className = 'laboo-card-title-row rvp-title-row';
    const titleLink = document.createElement('a');
    titleLink.href = link.href;
    titleLink.className = 'rvp-title laboo-card-title';
    titleLink.textContent = product.title || '';

    link.appendChild(image);
    item.appendChild(link);
    row.appendChild(titleLink);
    item.appendChild(row);
    return item;
  };

  const render = async (wrapper) => {
    if (wrapper.dataset.rvpLoaded === 'true') return;
    wrapper.dataset.rvpLoaded = 'true';

    const grid = wrapper.querySelector('[data-rvp-grid]');
    const handles = readHandles().slice(0, LIMIT);
    const rootUrl = wrapper.dataset.rootUrl || '/';

    if (!grid || handles.length === 0) {
      wrapper.hidden = true;
      return;
    }

    const products = await Promise.all(
      handles.map(async (handle) => {
        try {
          const response = await fetch(localizedProductUrl(rootUrl, handle, '.js'));
          return response.ok ? response.json() : null;
        } catch (error) {
          return null;
        }
      })
    );

    const fragment = document.createDocumentFragment();
    products.forEach((product) => {
      const item = createItem(product, rootUrl);
      if (item) fragment.appendChild(item);
    });

    grid.appendChild(fragment);
    if (!grid.children.length) wrapper.hidden = true;
  };

  const initialize = () => {
    saveCurrentProduct();

    document.querySelectorAll('[data-laboo-recently-viewed]').forEach((wrapper) => {
      const handles = readHandles();
      if (!handles.length) {
        wrapper.hidden = true;
        return;
      }

      if (!('IntersectionObserver' in window)) {
        render(wrapper);
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          observer.disconnect();
          render(wrapper);
        },
        { rootMargin: '600px 0px' }
      );

      observer.observe(wrapper);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
